import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { SECURITY_TYPE } from "config/const"

export const countryCodeList = [
  { securityType: SECURITY_TYPE.THGBY10.id, countryCode: "Top.GB.TH" },
  { securityType: SECURITY_TYPE.CNGBY10.id, countryCode: "Top.GB.CN" },
  { securityType: SECURITY_TYPE.JPGBY10.id, countryCode: "Top.GB.JP" },
  { securityType: SECURITY_TYPE.HKGBY10.id, countryCode: "Top.GB.HK" },
  { securityType: SECURITY_TYPE.USGBY10.id, countryCode: "Top.GB.US" },
  { securityType: SECURITY_TYPE.ZAGBY10.id, countryCode: "Top.GB.ZA" },
  { securityType: SECURITY_TYPE.KRGBY10.id, countryCode: "Top.GB.KR" },
  { securityType: SECURITY_TYPE.VNGBY10.id, countryCode: "Top.GB.VN" },
  { securityType: SECURITY_TYPE.RUGBY10.id, countryCode: "Top.GB.RU" },
  { securityType: SECURITY_TYPE.PHGBY10.id, countryCode: "Top.GB.PH" },
  { securityType: SECURITY_TYPE.IDGBY10.id, countryCode: "Top.GB.ID" },
  { securityType: SECURITY_TYPE.TWGBY10.id, countryCode: "Top.GB.TW" },
  { securityType: SECURITY_TYPE.GBGBY10.id, countryCode: "Top.GB.GB" },
  { securityType: SECURITY_TYPE.MYGBY10.id, countryCode: "Top.GB.MY" },
  { securityType: SECURITY_TYPE.EUGBY10.id, countryCode: "Top.GB.EU" },
  { securityType: SECURITY_TYPE.DEGBY10.id, countryCode: "Top.GB.DE" },
  { securityType: SECURITY_TYPE.FRGBY10.id, countryCode: "Top.GB.FR" },
  { securityType: SECURITY_TYPE.SGGBY10.id, countryCode: "Top.GB.SG" },
  { securityType: SECURITY_TYPE.NZGBY10.id, countryCode: "Top.GB.NZ" },
  { securityType: SECURITY_TYPE.AUGBY10.id, countryCode: "Top.GB.AU" },
  { securityType: SECURITY_TYPE.BRGBY10.id, countryCode: "Top.GB.BR" },
]

export type usePriceListAction = {
  type: "PRICE_LIST_CHANGE_TYPE" | "PRICE_CHANGE_PAGE" | "PRICE_LIST_RELOAD"
  newType?: string
  page?: number
}

export type usePriceListState = {
  name: string
  _take?: number
  _skip?: number
}

export const usePriceList = (
  state: usePriceListState,
  action: usePriceListAction
) => {
  switch (action.type) {
    case "PRICE_LIST_CHANGE_TYPE":
      return { ...state, name: action.newType }
    case "PRICE_CHANGE_PAGE":
      return { ...state, _skip: state._skip * (action.page - 1) }
    case "PRICE_LIST_RELOAD":
      return { ...state, _skip: 0 }
  }
}

type RequestPriceListAPIsType = (
  state: usePriceListState
) => Promise<APIResponse.Res>
export const requestPriceListAPIs: RequestPriceListAPIsType = async (
  state: usePriceListState
) => await APIs.SymbolDetail.PriceList({ Name: state.name })

type RequestFCPriceListAPIsType = (
  state: usePriceListState,
  country: string
) => Promise<APIResponse.Res>
export const requestFCPriceListAPIs: RequestFCPriceListAPIsType = async (
  state: usePriceListState,
  country: string
) => await APIs.SymbolDetail.PriceList({ Name: `FC.${country}.${state.name}` })
